import script from "./WorkOrderDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkOrderDetail.vue?vue&type=script&setup=true&lang=js"

import "./WorkOrderDetail.vue?vue&type=style&index=0&id=9019660c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9019660c"]])

export default __exports__